import { createReducer, on } from '@ngrx/store';
import * as BulkOrderActions from '../actions/bulk-order.action';
import { StateWithbulkOrder } from '../bulk-order.state';

export const initialState: StateWithbulkOrder = {
  checkProduct: null,
  submitProducts: null,
  isSelected: 1,
  uploadedFile: null,
  isSubmitted: false,
  cartName: '',
  tableData: [],
  errorContent: null,
  loading: null,
  success: null,
  error: null,
}

export const bulkOrderReducer = createReducer(
  initialState,
  on(BulkOrderActions.checkProducts, (state) => ({
    ...state,
    loading: true,
    success: null,
    error: null,
  })),
  on(BulkOrderActions.checkProductsFail, (state, { payload }) => ({
    ...state,
    loading: null,
    success: null,
    error: payload
  })),
  on(BulkOrderActions.checkProductsSuccess,
    (state: StateWithbulkOrder, { checkProduct }) => ({
      ...state,
      checkProduct,
      loading: null,
      success: true,
      error: null,
    })
  ),
  on(BulkOrderActions.nextButtonBulkOrder,
    (state: StateWithbulkOrder, { isSelected }) => ({
      ...state,
      isSelected
    })
  ),
  on(BulkOrderActions.submitBulkOrder, (state) => ({
    ...state,
    loading: true,
    success: null,
    error: null,
  })),
  on(BulkOrderActions.submitBulkOrderFail, (state, { payload }) => ({
    ...state,
    loading: null,
    success: null,
    error: payload
  })),
  on(BulkOrderActions.submitBulkOrderSuccess, (state: StateWithbulkOrder, { submitProducts }) => ({
    ...state,
    loading: null,
    success: true,
    error: null,
    submitProducts: {
      ...state.submitProducts,
      ...submitProducts, 
      loading: null,
      success: true,
      error: null,
    },
  })),
  on(BulkOrderActions.isSubmitted,
    (state: StateWithbulkOrder, { isSubmitted }) => ({
      ...state,
      isSubmitted
    })
  ),
  on(BulkOrderActions.cartNameBulkOrder,
    (state: StateWithbulkOrder, { cartName }) => ({
      ...state,
      cartName
    })
  ),
  on(BulkOrderActions.excelDataBulkOrder,
    (state: StateWithbulkOrder, { tableData }) => ({
      ...state,
      tableData
    })
  ),
  on(BulkOrderActions.FileError,
    (state: StateWithbulkOrder, { errorContent }) => ({
      ...state,
      errorContent,
    })
  ),
  on(BulkOrderActions.uploadedFileName,
    (state: StateWithbulkOrder, { uploadedFile }) => ({
      ...state,
      uploadedFile,
    })
  ),
  on(BulkOrderActions.resetAllStage, () => ({
    ...initialState
  })),
  on(BulkOrderActions.quantityUpdates,
    (state: StateWithbulkOrder, { itemId, qty }) => {
      const updatedFoundProductCodes = state.checkProduct.foundProductCodes.map(
        (item) => {
          if (item.partNumber === itemId) {
            return {
              ...item,
              quantity: qty,
            };
          }
          return item;
        }
      );
      return {
        ...state,
        checkProduct: {
          ...state.checkProduct,
          foundProductCodes: updatedFoundProductCodes,
        },
      };
    }
  ),
  on(BulkOrderActions.refurbishedUpdate,
    (state: StateWithbulkOrder, { prodId }) => {
      const updatedFoundProductCodes = state.checkProduct.foundProductCodes.map(
        (item) => {
          if (item.partNumber === prodId) {
            return {
              ...item,
              refurbished: !item.refurbished,
            };
          }
          return item;
        }
      );

      return {
        ...state,
        checkProduct: {
          ...state.checkProduct,
          foundProductCodes: updatedFoundProductCodes,
        },
      };
    }
  )
);
